<template>
    <div class="pad-container">
        <canvas
            ref="canvas"
            class="pad-border"
            :height="height"
            :width="width"
        ></canvas>
        <div class="controls">
            <button class="button" @click="clear">
                {{ $t("signature-pad.clear") }}
            </button>
        </div>
    </div>
</template>

<script>
const color = "black";
const thickness = 2;

export default {
    name: "signature-pad",
    props: {
        width: {
            type: Number,
            default: 400,
        },
        height: {
            type: Number,
            default: 200,
        },
    },
    data() {
        return {
            canvas: null,
            ctx: null,
            drawing: false,

            previousCoordinates: {},
            currentCoordinates: {},

            actualStrokes: [],
            undoneStrokes: [],
        };
    },
    mounted() {
        let canvas = this.$refs.canvas;
        this.ctx = canvas.getContext("2d");

        this.ctx.strokeStyle = color;
        this.ctx.lineWidth = thickness;
        this.ctx.lineCap = "round";

        canvas.addEventListener("mousemove", this.tryDraw);
        canvas.addEventListener("mousedown", this.enableDraw);
        canvas.addEventListener("mouseup", this.disableDraw);
        canvas.addEventListener("mouseout", this.disableDraw);

        this.canvas = canvas;
    },
    methods: {
        getSignature() {
            let data = this.canvas.toDataURL();
            return data;
        },
        clear() {
            this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
        },
        setCoordinates(e) {
            this.previousCoordinates = this.currentCoordinates;
            this.currentCoordinates = {
                x: e.offsetX,
                y: e.offsetY,
            };
        },
        tryDraw(e) {
            if (this.drawing) {
                this.setCoordinates(e);
                this.draw(this.previousCoordinates, this.currentCoordinates);
            }
        },
        draw(start, end) {
            this.ctx.beginPath();

            let prevX = start.x;
            let prevY = start.y;
            this.ctx.moveTo(prevX, prevY);

            let x = end.x;
            let y = end.y;
            this.ctx.lineTo(x, y);

            this.ctx.stroke();
            this.ctx.closePath();
        },
        drawDot(coordinates) {
            this.draw(coordinates, coordinates);
        },
        enableDraw(e) {
            this.setCoordinates(e);
            this.drawDot(this.currentCoordinates);
            this.drawing = true;
        },
        disableDraw() {
            this.drawing = false;
        },
    },
};
</script>

<style lang="scss" scoped>
.pad-container {
    display: flex;
    justify-content: center;
    align-items: center;
}

.pad-border {
    border: 0.5px solid #000;
}

.controls {
    margin: 1rem;
}
</style>